import React from "react";

import { Table, Switch } from "antd";

import styles from "./styles.module.css";

const ExtraComponent = ({ data, onExtraSelected }) => {
  const columns = [
    {
      title: "Items",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Yes/No",
      dataIndex: "selected",
      key: "selected",
      render: (text, record) => (
        <Switch
          size="small"
          checked={text}
          onChange={(value) => onExtraSelected(value, record)}
          checkedChildren="Yes"
          unCheckedChildren="No"
          className="custom-switch"
          style={{width: "60px"}}
        />
      ),
    },
    {
      title: "Price",
      dataIndex: "rateWithCC",
      key: "rateWithCC",
      render: (text, record) => (
        <span>{record.selected ? `$${text}` : "No Cost"}</span>
      ),
    },
  ];

  return (
    <div className={`row ${styles.extra_content_tab}`}>
      <Table
        className={`col-lg-8 col-md-8 ${styles.extra_table}`}
        dataSource={data}
        columns={columns}
        pagination={false}
      />
      <div className="col-lg-4 col-md-4">
        <div className={styles.extra_img}>
            <img src={"/assets/images/extra_circle.png"} alt="Mic" />
          </div>
      </div>
    </div>
  );
};

export default ExtraComponent;
